import { render, staticRenderFns } from "./screenShotInfo.vue?vue&type=template&id=4d537aaa&scoped=true"
import script from "./screenShotInfo.vue?vue&type=script&lang=js"
export * from "./screenShotInfo.vue?vue&type=script&lang=js"
import style0 from "./screenShotInfo.vue?vue&type=style&index=0&id=4d537aaa&prod&lang=css"
import style1 from "./screenShotInfo.vue?vue&type=style&index=1&id=4d537aaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d537aaa",
  null
  
)

export default component.exports